<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">姓名/手机号</div>
          <el-input size="mini" v-model="page.staffName" clearable class="ipt-sty" placeholder="请输入姓名/手机号"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">备案药企</div>
          <el-select size="mini" v-model="page.tenantGuid" filterable clearable placeholder="请选择备案药企" class="ipt-sty">
            <el-option
              v-for="item in companyList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">账单月份</div>
          <el-date-picker size="mini" class="ipt-sty" value-format="yyyy-MM" clearable v-model="page.accountMonth" type="month"
            placeholder="选择月">
          </el-date-picker>
        </el-col>
         <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">导入时间</div>
          <el-date-picker
          size="mini"
            class="ipt-sty"
            v-model="timeRange"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="截止时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">部门名称</div>
          <el-input v-model="page.organisationName" clearable class="ipt-sty" placeholder="请输入部门名称"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">账单周期</div>
          <el-input v-model="page.billCycle" clearable class="ipt-sty" placeholder="请输入账单周期"></el-input>
        </el-col>
       
      </el-row>
      <!-- <el-row :gutter="6" class="search-btn-box">
        <div class="fr" style="margin: 20px 20px 0 0">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </div>
      </el-row> -->
    </div>
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <div class="button-area">
        <div>
          <el-button icon="el-icon-plus" size="mini" type="info" @click="bitchExport">批量导出</el-button>
          <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1)">新增账单</el-button>
          <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
        </div>
        
        <div v-if="totalLoading">
          <span style="color: #FF5F1F;">正在合计中...</span>
        </div>
        <div v-else>
          <span style="margin-right: 6px;">合计服务收入：<span>{{  amountSumOne | numDigit }}</span>&nbsp;元</span>
          <span>合计平台服务费：<span>{{ amountSumTwo | numDigit }}</span>&nbsp;元</span>
        </div>
      </div>
      <el-table :height="tableHeight" :data="tableData"  stripe @selection-change="handleSelectionChange" border v-loading="tableWrapLoading"
        style="width: 100%">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="accountMonth"
          label="账单月份"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="90"
        >
          <!-- <template slot-scope="scope">{{ scope.row.accountMonth | getMonth }}</template> -->
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="备案药企"
          header-align="center"
          align="left"
          show-overflow-tooltip
          min-width="240"
        ></el-table-column>
        <el-table-column
          prop="organisationName"
          label="部门"
          header-align="center"
          align="left"
          sortable
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.organisationName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="billCycle"
          label="账单周期"
          header-align="center"
          align="left"
          sortable
          :sort-method="sortByIndex"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.billCycle || '-' }}</span>
            <!-- <span v-else>-</span> -->
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="billCycle"
          label="周期时间"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="205"
        >
          <template slot-scope="scope">{{
              scope.row.cycleStartDate ? scope.row.cycleStartDate + ' 至 ' + scope.row.cycleEndDate : '-'
          }}</template>
        </el-table-column> -->
        <el-table-column
          prop="salesTerritoryName"
          label="省区(服务区域)"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.salesTerritoryName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="姓名"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="96"
        ></el-table-column>
        <el-table-column
          prop="positionName"
          label="岗位"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.positionName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="mobileNo"
          label="手机号"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.mobileNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="idCode"
          label="身份证号"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.idCode || '-' }}</span>
          </template>
        </el-table-column>
        <!-- // ! 去掉基本工资\绩效费用 -->
        <!-- <el-table-column prop="baseSalary" label="基本工资(元)" header-align="center" align="right" show-overflow-tooltip
          width="140">
          <template slot-scope="scope">{{ scope.row.baseSalary | numFmt | numDigit }}</template>
        </el-table-column> -->
        <!-- <el-table-column prop="performanceSalary" label="绩效费用(元)" header-align="center" align="right"
          show-overflow-tooltip width="140">
          <template slot-scope="scope">{{ scope.row.performanceSalary | numFmt | numDigit }}</template>
        </el-table-column> -->
        <el-table-column prop="saleSalary" label="服务收入(元)" header-align="center" align="right" show-overflow-tooltip
          width="140">
          <template slot-scope="scope">{{ scope.row.saleSalary | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column prop="serviceAmount" label="平台服务费(元)" header-align="center" align="right" show-overflow-tooltip
          width="140">
          <template slot-scope="scope">{{ scope.row.serviceAmount | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="bankName"
          label="银行名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="130"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bankName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bankDetailName"
          label="银行行号"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bankDetailName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bankCard"
          label="银行卡号"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bankCard || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="导入时间" width="180" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="140">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除 </a>
            <a class="txt-color" @click="add(3, scope.row)"> | 详情</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10,20,50,100,200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- 弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="1000px">
      <div class="form-box">
        <div class="form-list">
          <label for=""><span>*</span>账单月份</label>
          <div class="form-input">
            <el-date-picker
              :disabled="dialogType == 3 ? true : false"
              class="w100f"
              value-format="yyyy-MM"
              clearable
              v-model="ruleForm.accountMonth"
              type="month"
              placeholder="请选择"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="form-list">
          <label for=""><span>*</span>备案药企</label>
          <div class="form-input">
            <el-select
              :disabled="dialogType == 3 ? true : false"
              filterable
              class="w100f"
              clearable
              v-model="ruleForm.tenantGuid"
              placeholder="请选择"
              @change="getStaffChange"
            >
              <el-option
                v-for="item in companyList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-list">
          <label for="">
            <el-tooltip class="item" effect="dark" content="若某些药企同一个月同一个人多份账单，则必须选择周期！" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
            账单周期
          </label>
          <div class="form-input">
            <el-select
              :disabled="dialogType == 3 ? true : false"
              class="w100f"
              v-model="ruleForm.billCycle"
              placeholder="请选择账单周期"
            >
              <el-option v-for="(item, index) in billCycleOption" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="form-list">
          <label for="">周期范围</label>
          <div class="form-input">
            <el-date-picker
              :disabled="dialogType == 3 ? true : false"
              class="w100f"
              :format="'MM-dd'"
              value-format="yyyy-MM-dd"
              v-model="cycleDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div> -->
        <div class="form-list">
          <label for=""><span>*</span>收款人姓名</label>
          <div class="form-input">
            <el-select
              :disabled="dialogType == 3 ? true : false"
              class="w100f"
              clearable
              v-model="ruleForm.staffGuid"
              placeholder="请选择"
              @focus="getStaff()"
              @change="getStaffDetail(ruleForm.staffGuid)"
              filterable
              v-loading="staffLoading"
            >
              <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="form-list">
          <label for="">收款人手机号</label>
          <div class="form-input">
            <el-input disabled v-model="ruleForm.mobileNo" clearable placeholder=""></el-input>
          </div>
        </div>
        <div class="form-list">
          <label for="">身份证号码</label>
          <div class="form-input">
            <el-input disabled v-model="ruleForm.idCode" clearable placeholder=""></el-input>
          </div>
        </div>
        <div class="form-list">
          <label for="">银行名称</label>
          <div class="form-input">
            <el-input
              :disabled="dialogType == 3 ? true : false"
              v-model="ruleForm.bankName"
              clearable
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <div class="form-list">
          <label for="">银行行号</label>
          <div class="form-input">
            <el-input :disabled="dialogType == 3 ? true : false" v-model="ruleForm.bankDetailName" clearable
              placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="form-list">
          <label for="">
            <span v-if="!isThirdPartyContractor">*</span>
            银行卡号
          </label>
          <div class="form-input">
            <el-input
              :disabled="dialogType == 3 ? true : false"
              v-model="ruleForm.bankCard"
              clearable
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <!-- //!去掉基本工资\绩效费用  -->
        <!-- <div class="form-list">
          <label for="">基本工资</label>
          <div class="form-input">
            <el-input
              :disabled="dialogType == 3 ? true : false"
              v-model="ruleForm.baseSalary"
              clearable
              placeholder="请输入"
              oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)"
            ></el-input>
            <p>大写金额{{ ruleForm.baseSalary | smallToBig }}</p>
          </div>
        </div> -->
        <!-- <div class="form-list">
          <label for="">绩效费用</label>
          <div class="form-input">
            <el-input
              :disabled="dialogType == 3 ? true : false"
              v-model="ruleForm.performanceSalary"
              clearable
              placeholder="请输入"
              oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)"
            ></el-input>
            <p>大写金额{{ ruleForm.performanceSalary | smallToBig }}</p>
          </div>
        </div> -->
        <div class="form-list">
          <label for="">服务收入</label>
          <div class="form-input">
            <el-input
              :disabled="dialogType == 3 ? true : false"
              v-model="ruleForm.saleSalary"
              clearable
              placeholder="请输入"
              oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)"
            ></el-input>
            <p>大写金额{{ ruleForm.saleSalary | smallToBig }}</p>
          </div>
        </div>
        <div class="form-list">
          <label for="">平台服务费</label>
          <div class="form-input">
            <el-input
              :disabled="dialogType == 3 ? true : false"
              v-model="ruleForm.serviceAmount"
              clearable
              placeholder="请输入"
              oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)"
            ></el-input>
            <p>大写金额{{ ruleForm.serviceAmount | smallToBig }}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-show="dialogType !== 3">
        <el-button size="medium" plain @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="submitFile(1)"
          v-loading.fullscreen.lock="fullscreenLoading">保存并继续添加</el-button>
        <el-button size="medium" type="info" @click="submitFile()" v-loading.fullscreen.lock="fullscreenLoading">保
          存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'

export default {
  mixins:[getTenantDetail],
  data() {
    return {
      ServiceProviderTypeEnum,
      serviceProviderType:'',
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      timeRange: [],
      input: '',
      title: '添加账单',
      dialogFormVisible: false,
      fullscreenLoading: false,
      tableLoading: false,
      tableWrapLoading: false,
      totalLoading:true,
      value2: '',
      dialogType: 1,
      ruleForm: {
        serviceTenantGuid:localStorage.serviceTenantGuid,
        guid: null,
        tenantGuid: null,
        tenantName: null,
        staffGuid: null,
        staffName: null,
        accountMonth: null,
        bankName: null,
        bankDetailName: null,
        bankCard: null,
        // !baseSalary: '',
        // !performanceSalary: '',
        saleSalary: '',
        serviceAmount: '',
        idCode: null,
        mobileNo: null,
        billCycle: null,
        // cycleStartDate: null,
        // cycleEndDate: null,
      },
      companyList: [], //公司选择\
      staffList: [], //人员列表
      idCode: '', //身份证号
      mobileNo: '', //手机号
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        staffName: '',
        organisationName: '',
        accountMonth: '',
        serviceTenantGuid: '',
        startTime: null,
        endTime: null,
        billCycle: '',
      },
      tableData: [],
      multipleSelection: [],
      staffLoading: false,
      billCycle: null, //周期
      billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      // cycleDate: null, //周期范围起止
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.getMonthStartOrEnd(1, this.ruleForm.accountMonth) ||
            time.getTime() > this.getMonthStartOrEnd(2, this.ruleForm.accountMonth)
          );
        },
      },
      amountSumOne:'',//合计收款金额
      amountSumTwo:'',//合计收款金额
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getServiceProviderType();
    this.Mixins_getServiceProviderType();
    // this.getCurrentMonth();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    }
  },
  computed: {
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    sortByIndex(a, b) {
      const indexMap = {
        '一期': 1,
        '二期': 2,
        '三期': 3,
        '四期': 4,
        '五期': 5,
        '六期': 6,
        '七期': 7,
        '八期': 8,
        '九期': 9,
        '十期': 10,
        '十一期': 11,
        '十二期': 12,
        '十三期': 13,
        '十四期': 14,
        '十五期': 15,
        '十六期': 16,
        '十七期': 17,
        '十八期': 18,
        '十九期': 19,
        '二十期': 20,
        '二十一期': 21,
        '二十二期': 22,
        '二十三期': 23,
        '二十四期': 24,
        '二十五期': 25,
        '二十六期': 26,
        '二十七期': 27,
        '二十八期': 28,
        '二十九期': 29,
        '三十期': 30,
      };
      return indexMap[a.billCycle] - indexMap[b.billCycle];
    },
    setOptionWidth(event){
      this.$nextTick(() => {
        this.selectOptionWidth = event.srcElement.offsetWidth + "px";
      }); 
    },
    getCurrentMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      let toMonth = year + '-' + (month + 1);
      this.ruleForm.accountMonth = toMonth;
    },
    // type 1为开始时间，2为结束时间    monthDate 月份yyyy-MM
    getMonthStartOrEnd(type, monthDate) {
      let time = null;
      if (type == 1) {
        time = this.$moment(monthDate).startOf('month').valueOf();
      } else {
        time = this.$moment(monthDate).endOf('month').valueOf();
      }
      return time;
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        staffName: '',
        organisationName: '',
        accountMonth: '',
        serviceTenantGuid: '',
        billCycle: '',
      };
      this.timeRange = [];
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.accountMonth = self.page.accountMonth.replace('-', '');
      let query = JSON.parse(JSON.stringify(self.page));
      // console.log('getData ',query);
      // return
      query.accountMonth = query.accountMonth?query.accountMonth.replace('-', ''):'';
      query.serviceTenantGuid = localStorage.guid;
      console.log(this.timeRange);
      if (this.timeRange && this.timeRange.length) {
        query.startTime = this.timeRange[0]+ ' 00:00:00';
        query.endTime = this.timeRange[1]+ ' 23:59:59';
      }
      this.getAmount(query)
      self.tableWrapLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableWrapLoading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAmount(query) {
      let self = this;
      let req=JSON.parse(JSON.stringify(query))
      req.pageSize=-1
      self.totalLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/amount-sum`, req).then((res) => {
        self.totalLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.amountSumOne = res.data.data.amountSumOne;
          self.amountSumTwo = res.data.data.amountSumTwo;
          self.$forceUpdate()
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getStaff() {
      if (this.ruleForm.tenantGuid == '' || this.ruleForm.tenantGuid == null) {
        this.$message.error('请先选择药企!');
        return;
      }
    },
    //获取人员列表
    getStaffChange(val) {
      let self = this;
      self.companyList.forEach((i) => {
        if (self.ruleForm.tenantGuid == i.sendTenantGuid) {
          self.ruleForm.tenantName = i.sendTenantName;
        }
      });
      self.ruleForm.staffGuid = val == 1 ? self.ruleForm.staffGuid : '';
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.ruleForm.tenantGuid,
      };
      self.staffLoading = true;
      return new Promise((resolve, reject) => {
        self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffList = res.data.data.records;
            self.staffLoading = false;
            resolve();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    //获取人员详情
    getStaffDetail(guid) {
      let self = this;
      if (self.staffList != null && self.staffList.length > 0) {
        self.staffList.forEach((i) => {
          if (guid == i.guid) {
            self.ruleForm.staffName = i.staffName;
            self.ruleForm.mobileNo = i.mobileNo;
            self.ruleForm.idCode = i.idCode;
          }
        });
      }
    },
    getServiceProviderType() {
      let url = `/${serverConfig.msCustomerService}/tenant-expand/servicer-credential/detail?tenantGuid=${localStorage.guid}`;
      this.api.get(url).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.serviceProviderType = data.data.serviceProviderType;
            this.getCompany();
        }
      });
    },
    //获取公司
    getCompany() {
      let self = this;
      let serviceProviderType = this.serviceProviderType;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType: serviceProviderType == 3 ? '2' : (serviceProviderType == 1 || serviceProviderType == 2) ? '13' : ''
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.companyList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //批量导出
    bitchExport() {
      let self = this;
      self.fullscreenLoading = true;
      let resultData = JSON.parse(JSON.stringify(self.page));
      resultData.accountMonth = resultData.accountMonth.replace('-', '');
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/export`, resultData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    //点击新增或修改弹框
    add(type, row) {
      let self = this;
      self.dialogType = type;
      if (type == 1) {
        self.title = '新增账单';
        self.ruleForm = {
          serviceTenantGuid:localStorage.guid,
          guid: null,
          tenantGuid: null,
          staffGuid: null,
          accountMonth: null,
          bankName: null,
          bankDetailName: null,
          bankCard: null,
          // ! baseSalary: '', // 基本工资
          // ! performanceSalary: '', // 绩效费用
          saleSalary: '',
          serviceAmount: '',
          idCode: null,
          mobileNo: null,
          // cycleStartDate: null,
          // cycleEndDate: null,
          billCycle: null,
        };
        // self.cycleDate = null;
        self.multipleSelection = [];
        self.dialogFormVisible = true;
      } else {
        self.title = type == 2 ? '编辑账单' : '账单详情';
        self.dialogFormVisible = true;
        self.ruleForm.guid = row.guid;
        self.multipleSelection = [];
        self.ruleForm.tenantGuid = row.tenantGuid;
        self.ruleForm.accountMonth = row.accountMonth.substr(0, 4) + '-' + row.accountMonth.substr(4, 2);
        self.ruleForm.bankName = row.bankName;
        self.ruleForm.bankDetailName = row.bankDetailName;
        self.ruleForm.bankCard = row.bankCard;
        // ! self.ruleForm.baseSalary = row.baseSalary ? Number(row.baseSalary).toFixed(3) : '';
        // ! self.ruleForm.performanceSalary = row.performanceSalary ? Number(row.performanceSalary).toFixed(3) : '';
        self.ruleForm.saleSalary = row.saleSalary ? Number(row.saleSalary).toFixed(3) : '';
        self.ruleForm.serviceAmount = row.serviceAmount ? Number(row.serviceAmount).toFixed(3) : '';
        self.ruleForm.billCycle = row.billCycle;
        // if (row.cycleStartDate && row.cycleEndDate) {
        //   self.cycleDate = [row.cycleStartDate, row.cycleEndDate];
        // } else {
        //   self.cycleDate = null;
        // }
        // self.ruleForm.cycleStartDate = row.cycleStartDate;
        // self.ruleForm.cycleEndDate = row.cycleEndDate;
        self.getServiceProviderType();
        self.getStaffChange(1).then(() => {
          self.ruleForm.staffGuid = row.staffGuid;
          self.staffList.forEach((i) => {
            if (self.ruleForm.staffGuid == i.guid) {
              self.ruleForm.staffName = i.staffName;
              self.ruleForm.mobileNo = i.mobileNo;
              self.ruleForm.idCode = i.idCode;
            }
          });
          self.ruleForm.idCode = self.ruleForm.idCode ? self.ruleForm.idCode : row.idCode;
        });
        console.log(self.ruleForm.staffGuid);
        // self.getEditDetail(guid);
      }
    },
    //提交
    submitFile(type) {
      let self = this;
      if (!self.ruleForm.accountMonth) {
        self.$message.error('请选择账单月份！');
        return;
      }
      if (!self.ruleForm.tenantGuid) {
        self.$message.error('请选择药企！');
        return;
      }
      // if (self.ruleForm.billCycle && !self.cycleDate) {
      //   self.$message.error('请选择周期范围！');
      //   return;
      // }
      // if (!self.ruleForm.billCycle && self.cycleDate && self.cycleDate.length) {
      //   self.$message.error('请选择账单周期！');
      //   return;
      // }
      if (!self.ruleForm.staffGuid) {
        self.$message.error('请选择收款人！');
        return;
      }
      // if (!self.ruleForm.bankName) {
      //   self.$message.error('请输入银行名称！');
      //   return;
      // }

      // if (!self.ruleForm.bankDetailName) {
      //   self.$message.error('请输入银行行号！');
      //   return;
      // }
      // 是三方合作商 银行卡号 非必填
      if (!self.ruleForm.bankCard && !this.isThirdPartyContractor) {
        self.$message.error('请输入银行卡号！');
        return;
      }
      if (!self.ruleForm.saleSalary) {
        self.$message.error('请输入服务收入！');
        return;
      }
      let resultData = JSON.parse(JSON.stringify(self.ruleForm));
      resultData.accountMonth = resultData.accountMonth.replace('-', '');
      // if (self.cycleDate && self.cycleDate.length > 0) {
      //   resultData.cycleStartDate = self.cycleDate[0];
      //   resultData.cycleEndDate = self.cycleDate[1];
      // }

      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/edit`, resultData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.getData();
          self.fullscreenLoading = false;
          if (type) {
            self.ruleForm = {
              guid: null,
              tenantGuid: null,
              staffGuid: null,
              accountMonth: null,
              bankName: null,
              bankDetailName: null,
              bankCard: null,
              // ! baseSalary: '',
              // ! performanceSalary: '',
              saleSalary: '',
              serviceAmount: '',
              idCode: null,
              mobileNo: null,
              billCycle: null,
              // cycleStartDate: null,
              // cycleEndDate: null,
              serviceTenantGuid:localStorage.guid
            };
          } else {
            this.dialogFormVisible = false;
          }
          self.$message.success('保存成功！');
        } else {
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      });
    },
    getDeleteData(flg, guid) {
      let self = this;
      let guids = [];
      if (flg == 1) {
        if (this.multipleSelection.length == 0) {
          this.$message.error('请勾选数据！');
        } else {
          this.multipleSelection.forEach((el) => {
            guids.push(el.guid);
          });
          this.$confirm('此操作将永久删除, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            self.api
              .postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/batch-delete`, guids)
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.multipleSelection = [];
                  self.$message.success('删除成功');
                  self.getData(true);
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          });
        }
      } else {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/salary/delete?guid=${guid}`)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.multipleSelection = [];
                self.$message.success('删除成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
      }
    },
    getEditDetail(guid) {
      let self = this;
      self.api.get(`/${serverConfig.msSalesPerformService}/resource/data/detail?guid=` + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.ruleForm.fileName = res.data.data.fileName;
          self.ruleForm.fileDesc = res.data.data.fileDesc;
          self.ruleForm.staffGuids = JSON.parse(res.data.data.staffGuids);
          self.ruleForm.tenantGuid = res.data.data.tenantGuid;
          let attach = JSON.parse(res.data.data.attach);
          self.ruleForm.attach = [];
          self.fileList = [];
          self.ruleForm.attach = attach;
          let item = {
            name: attach[0].fileName,
            path: attach[0].path,
          };
          self.fileList.push(item);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //选择表格数据
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = val;
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
<style scoped>
.el-col-5 {
  width: 30%;
}
/* .content /deep/ .el-select-dropdown{
  min-width: 280px !important
} */
.chooseBox {
  display: flex;
  /* justify-content: center; */
  /* margin-top: 30px; */
}

.upload-txt {
  line-height: 6px;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.txt-color {
  text-decoration: none;
}

.clear-person {
  color: #4fa1a4;
  float: right;
  margin-right: 20px;
  text-decoration: underline;
  cursor: pointer;
}

.search-area-div {
  /* width: 100px; */
  flex-shrink: 0;
}

.form-box {
  display: flex;
  flex-wrap: wrap;
}

.form-box .form-list {
  display: flex;
  width: 48%;
  margin-bottom: 20px;
  padding: 0 2%;
  box-sizing: border-box;
}

.form-box .form-list label {
  width: 120px;
  flex-shrink: 0;
  text-align: right;
  line-height: 36px;
  margin-right: 16px
}

.form-box .form-list label span {
  color: red;
}

.form-box .form-list .form-input {
  flex: 1;
  width: 100%;
}

.form-box .form-list .form-input p {
  color: #4fa1a4;
  text-align: left;
  margin-bottom: 0 !important;
}

.W250 {
  width: 250px;
}
.el-col-6{
  display: flex;
}
.button-area{
  display: flex;
  justify-content:space-between;
  align-items: center
}
</style>
